import { ReactNode, ErrorInfo, Component } from 'react';
import { withRouter } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { BodyText, Button, Div, Title } from '@gaiads/telia-react-component-library';
import { withTranslation, WithTranslationProps } from 'react-i18next';

interface Props extends RouteComponentProps, WithTranslationProps {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch = (error: Error, errorInfo: ErrorInfo): void => {
    console.error('Uncaught error:', error, errorInfo);
  };

  restart = (): void => {
    this.setState({ hasError: false });
    if (this.props.location.pathname.includes('/onboarding')) {
      this.props.history.push('/onboarding/getstarted');
    } else {
      this.props.history.push('/');
    }
  };

  render() {
    const { i18n } = this.props;
    if (this.state.hasError) {
      return (
        <Div margin={{ size: 'xxlg' }}>
          <Title>{i18n!.t('globalComponents:TopErrorBoundary.title')}</Title>
          <BodyText size="md" margin={{ top: 'lg' }}>
            {i18n!.t('globalComponents:TopErrorBoundary.text')}
            <Button margin={{ left: 'md' }} onClick={this.restart}>
              {`${i18n!.t('globalComponents:TopErrorBoundary.buttonText')}`}
            </Button>
          </BodyText>
        </Div>
      );
    } else {
      return this.props.children;
    }
  }
}

export default withTranslation()(withRouter(ErrorBoundary));
